import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { AnimatedAnnouncementFeed } from "@/components/announcements/AnimatedAnnouncementFeed";

export const AnnouncementsCard = () => {
  const { data: announcements = [], isLoading } = useQuery({
    queryKey: ["dashboard-announcements"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("announcements")
        .select("id, title, content, priority, category, created_at, file_url")
        .eq("published", true)
        .order("created_at", { ascending: false })
        .limit(5);
      if (error) throw error;
      return data ?? [];
    },
  });

  return (
    <AnimatedAnnouncementFeed
      announcements={announcements}
      title="News & Announcements"
      emptyMessage="No announcements at this time"
      isLoading={isLoading}
    />
  );
};
